import SearchList from '../../antd/Lists/SearchList'

const SectorsList = ({ bordered, pinned = null, sectors = [], selected, maxHeight, onSelectedChange }) => {
  const options = [...sectors]
    .sort((a, b) => {
      /** A service proposed as a duplicate opens the list : one pre-selected halfway down is one nobody ever sees. */
      if (pinned !== null && (a.id === pinned || b.id === pinned)) {
        return a.id === pinned ? -1 : 1
      }

      /** Every other service keeps the order the institution sent them in. */
      return 0
    })
    .map(sector => ({
      label: sector.name,
      value: sector.id,
      tooltip: sector.name
    }))

  return (
    <div className='h-100'>
      <SearchList
        selected={selected}
        data={options}
        maxHeight={maxHeight}
        onSelectedChange={onSelectedChange}
      />
    </div>
  )
}

export default SectorsList
